// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"158":"fac93744","647":"0a90ccdf"}[chunkId] + ".js";
};